module.exports = __webpack_public_path__ + "static/assets/8bd98f3c4973bbc117baf4db16a97102.png";